import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-business-coaching-about',
  templateUrl: './business-coaching-about.component.html',
  styleUrls: ['./business-coaching-about.component.scss']
})
export class BusinessCoachingAboutComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
